<template>
  <!-- 普本专业 -->
  <el-button-group>
    <el-button type="primary" size="large" @click="addFnc($event)"
      ><el-icon><Plus /></el-icon>添加普本专业</el-button
    >
  </el-button-group>
  <!-- 表格组件 -->
  <TableList
    componentTableId="PbMajor"
    @update-list="updateList"
    excelName="普本专业"
    :table-data="tableData"
    :header-data="headerData"
    :table-height="tableMaxHeight"
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @editFnc="editFnc"
    @deleteFnc="deleteFnc"
    @searchFnc="searchFnc"
  >
    <!-- 关联院校 -->
    <template #relevanceCountCustom="scope">
      <span v-if="scope.scope.relevanceCount && scope.scope.relevanceCount > 0">
        共{{ scope.scope.relevanceCount }}个院校</span
      >
      <span class="gray" v-else> 未设置</span>
    </template>
  </TableList>
  <!-- 底部工具 -->
  <Pagination
    :pagination="pagination"
    :is-loading="loading"
    @change-pagination="changePagination"
  >
  </Pagination>
  <!-- 添加编辑 普本专业管理 -->
  <el-dialog
    class="dialogNoPadding"
    :before-close="handleClose"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    width="550px"
  >
    <AddEditPbMajor
      ref="AddEditComponent"
      v-if="addEditVisible"
      v-bind:isEdit="isEdit"
      :edit-obj="editObj"
      :years-sel="yearsSel"
      :category-sel="majorCategorySel"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditPbMajor>
  </el-dialog>
</template>

<script>
import TableList from "components/TableList.vue";
import Pagination from "components/Pagination.vue";
import { reactive, onMounted, toRefs, ref, toRaw } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus,getYear } from "common/utils";
import { getMajorPtList, delMajorPt } from "network/pbMajor.js";
import { getMajorCategory } from "network/majorCategory.js";
import AddEditPbMajor from "views/pbMajor/AddEditPbMajor.vue";

export default {
  name: "PbMajor",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    Pagination,
    AddEditPbMajor,
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      //表格数据
      tableData: [],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        },{
          label: "专业名称",
          prop: "name",
          width: "200",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
        },
        {
          label: "所属年份",
          prop: "year",
          width: "200",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "所属专业类别",
          prop: "majorCategoryName",
          width: "200",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
        },
        {
          label: "关联院校",
          prop: "relevanceCount",
          width: "200",
          align: "center",
          noSetText: "未设置",
          custom: true,
        },
        {
          label: "操作",
          prop: "operation",
          width: "200",
          align: "center",
          fixed: "right",
          operation: true,
          edit: true,
          delete: true,
        },
      ],
      //筛选项
      search: {
        name: null, //筛选 普本专业名称
        year: null, //筛选 年份
        majorCategoryId: null,
      },
      yearsSel: [], //年份下拉选项
      categoryValue: "", //筛选 专业类别
      majorCategorySel: [], //专业类别下拉选项
      dialogTitle: "添加普本专业",
      addEditVisible: false, //添加编辑弹窗
      editObj: {},
      isEdit: false, //是否是编辑
    });
    //挂载后调用函数获取项目数据
    onMounted(() => {
      getMajorCategoryList(); //获取专业类别
      getMarjorData(""); //请求普本专业列表数据
      // 获取年份下拉框
      data.yearsSel = getYear(16);
       data.headerData.map((item) => {
        if (item.prop == "year") {
          item.selectOptions = data.yearsSel;
        }
      });
    });

    //获取专业类别下拉
    function getMajorCategoryList() {
      getMajorCategory(true)
        .then((res) => {
          if (res.code == 1) {
            data.majorCategorySel = res.result;
            data.headerData.map((item) => {
              if (item.prop == "majorCategoryName") {
                item.selectOptions = data.majorCategorySel;
              }
            });
          } else {
            ElMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // 获取列表
    const getMarjorData = (type) => {
      data.loading = true;
      const obj = {
        name: data.search.name || null,
        year: data.search.year || null,
        majorCategoryId: data.search.majorCategoryId || null,
        pageIndex: data.pagination.currentPage,
        pageSize: data.pagination.pageSize,
      };
      getMajorPtList(obj)
        .then((result) => {
          
          if (result && result.code == 1) {
            const list = result.result.rows;
            data.pagination.total = result.result.totalCount;
            const dataList = toRaw(list);
            data.tableData = dataList;
            data.loading = false;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "name") {
        data.search.name = val.value;
      }
      if (val.prop && val.prop == "year") {
        data.search.year = val.value;
      }
      if (val.prop && val.prop == "majorCategoryName") {
        data.search.majorCategoryId = val.value;
      }
      data.pagination.currentPage = 1;
      getMarjorData();
    };

    //更新列表
    const updateList = () => {
      getMarjorData();
    };

    // 添加/编辑普本专业
    const addFnc = (e) => {
      // 强制移除按钮焦点
      lostFocus(e);
      data.addEditVisible = true;
      data.dialogTitle = "添加普本专业";
      data.editObj = {};
      data.isEdit = false;
    };

    // 编辑
    const editFnc = (obj) => {
       data.addEditVisible = true;
      data.dialogTitle = `编辑【${obj.name}】专业`;
      data.editObj = obj;
      data.isEdit = true;
    };

    // 删除
    const deleteFnc = (obj) => {
      ElMessageBox.confirm(`是否删除[${obj.name}]专业？`, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteData(obj.id);
        })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    function deleteData(id) {
      delMajorPt(id)
        .then((result) => {
          
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }

    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };

    // 分页
    const changePagination = (val) => {
      data.pagination = toRaw(val);
      updateList();
    };

 //关闭添加编辑弹窗操作
    const AddEditComponent = ref();
    const handleClose = () => {
      if (data.addEditVisible) {
        AddEditComponent.value.resetForm();
        data.addEditVisible = false;
      }
    };

    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getMarjorData,
      searchFnc,
      updateList,
      addFnc,
      editFnc,
      deleteFnc,
      closeDialog,
      changePagination,
      AddEditComponent,
      handleClose,
    };
  },
};
</script>
<style scoped>
</style>

